export default __webpack_public_path__ + "static/media/5.36a37fd6.png";